import Cookies from "js-cookie";
import { sendAnalyticsNonInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import { createSession as createSessionFromApi } from "src/api/v1.6/auth/session";
import { createInitializeAuth } from "src/api/v1.6/auth/initialize";
import { logout_google } from "../sdks/GoogleAuthSdk";
import type { UserProfileUpdateValues } from "./user";
import { logFetchError } from "./log";
export type AuthType = "google" | "apple" | "OneTimePassword";

const SESSION_COOKIE_NAME = "r2r_session";
const SESSION_COOKIE_DOMAIN = ".rome2rio.com";

export function isLoggedIn() {
  return Cookies.get(SESSION_COOKIE_NAME) !== undefined;
}

function createSessionCookie(sessionToken: string) {
  Cookies.set(SESSION_COOKIE_NAME, sessionToken, {
    expires: 364,
    secure: true,
    sameSite: "none",
    domain: SESSION_COOKIE_DOMAIN,
  });
}

function removeSessionCookie() {
  Cookies.remove(SESSION_COOKIE_NAME, {
    domain: SESSION_COOKIE_DOMAIN,
  });
}

type InitializeAuthResponse = {
  browserId: string;
};

export async function createSession(
  token: string,
  authType: AuthType,
  defaultUserProfile?: UserProfileUpdateValues,
) {
  try {
    const result = await createSessionFromApi({
      token,
      authMethod: authType,
      defaultUserProfile,
    });

    if (result.sessionId && result.user) {
      createSessionCookie(result.sessionId);
      sendAnalyticsNonInteractionEvent({
        category: "UserAccount",
        action: result.action,
        label: authType,
      });
      return result.user;
    }
  } catch (err) {
    logFetchError(err);
  }
}

export async function initializeAuth(
  emailAddress: string,
): Promise<InitializeAuthResponse | undefined> {
  try {
    return await createInitializeAuth({ emailAddress });
  } catch (err) {
    logFetchError(err);
  }
  return undefined;
}

export function clearLocalSessionState() {
  removeSessionCookie();
  logout_google();
}
